import React from "react";
import { useTheme } from "@nivo/core";
import { Chip, TableTooltip } from "@nivo/tooltip";

export const TooltipBothAxes = ({ slice, axis }) => {
    const theme = useTheme();
    const otherAxis = axis === "x" ? "y" : "x";
  
    return (
      <TableTooltip
        rows={[
          [
            "",
            <div><strong style={{whiteSpace: "nowrap"}}>{slice.points[0].data.x.toString()}</strong></div>,
            <span key="value" style={theme.tooltip.tableCellValue}>              
            </span>,
          ],
          ...slice.points.map((point) => [
            <Chip
              key="chip"
              color={point.serieColor}
              style={{whiteSpace: "nowrap", ...theme.tooltip.chip}}
            />,
            <span style={{whiteSpace: "nowrap"}}>{point.serieId}</span>,
            <span key="value" style={{whiteSpace: "nowrap", ...theme.tooltip.tableCellValue}}>
              {point.data[`${otherAxis}Formatted`]}
            </span>,
          ]),
        ]}
      />
    );
  };